export function getGridPlugs(
  itemsCount: number,
  perChunk: number,
  gridColumns: number
): null[] {
  if (itemsCount === 0 || itemsCount === perChunk) {
    return [];
  }

  const gamesInLastChunk =
    itemsCount > perChunk
      ? itemsCount - perChunk * Math.floor(itemsCount / perChunk)
      : itemsCount;

  const lastRowGames = gamesInLastChunk % gridColumns;
  const plugsCount = lastRowGames === 0 ? 0 : gridColumns - lastRowGames;

  return Array(plugsCount).fill(null);
}
